import { useMutation, useQuery } from 'react-query';
import useAuth from './useAuth';
import useFormBuilder from './useFormBuilder';

export default function useClinicDocuments() {
  const { request, userId } = useAuth();
  const { userForms, forms, userFormsIsLoading, refetch, updateForm, refetchForms } = useFormBuilder({ userId });
  // Fetch Documents
  const {
    data: documents,
    refetch: refetchDocuments,
    isLoading: isDocumentsLoading,
    isRefetching
  } = useQuery(['/clinic-documents'], () =>
    request.get('/clinic-documents').then(({ data }) => {
      return data;
    })
  );
  const { mutateAsync: saveDocuments, isLoading: isSavingDocument } = useMutation(
    '/clinic-documents',
    (payload: any) => request.post('/clinic-documents', payload).then((response) => response.data),
    {
      onSuccess: () => {
        refetchDocuments();
      }
    }
  );

  // Form Builder form hook
  const { mutateAsync: createCustomTemplate, isLoading: isCreatingCustomTemplate } = useMutation(
    `/clinic-documents/custom-template/`,
    (payload: any) => request.post(`/clinic-documents/custom-templates/`, payload).then(({ data }) => data as any),
    {
      onSuccess: () => {
        // refetchDocuments();
        refetchDocuments();
      }
    }
  );
  // Form Builder template hook

  const { mutateAsync: createCustomForm, isLoading: isCreatingCustomForm } = useMutation(
    `/clinic-documents/custom-forms`,
    (payload: any) => request.post(`/clinic-documents/custom-forms`, payload).then(({ data }) => data as any),
    {
      onSuccess: () => {
        // refetchDocument();
        refetchDocuments();
        refetchForms();
      }
    }
  );

  return {
    saveDocuments,
    isSavingDocument,
    documents,
    refetchDocuments,
    isDocumentsLoading, // Form builder hook up
    createCustomTemplate,
    createCustomForm,
    isCreatingCustomForm,
    isCreatingCustomTemplate
  };
}
